import Loadable from '@comeon/loadable';

const EMPTY = () => <div />;
const IngameDesktopHeader = Loadable({
	loader: () => import('./ingame-desktop-header.js'),
	loading: EMPTY
});

export default IngameDesktopHeader;
